module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "never"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "top",
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入标题"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "副标题"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入副标题"
    },
    model: {
      value: (_vm.form.summary),
      callback: function($$v) {
        _vm.$set(_vm.form, "summary", $$v)
      },
      expression: "form.summary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "作者名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.author),
      callback: function($$v) {
        _vm.$set(_vm.form, "author", $$v)
      },
      expression: "form.author"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "作者头像"
    }
  }, [_c('imgBox', {
    attrs: {
      "imgUrl": _vm.form.head_portrait,
      "inline": ""
    },
    on: {
      "click": _vm.handleImgChange
    }
  }), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文章类目选择"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.category_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "category_id", $$v)
      },
      expression: "form.category_id"
    }
  }, _vm._l((_vm.categoryList), function(item) {
    return _c('el-option', {
      key: item.category_id,
      attrs: {
        "label": item.category_name,
        "value": item.category_id
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.renderable) ? _c('el-form-item', {
    attrs: {
      "label": "地区选择"
    }
  }, [_c('region-select', {
    attrs: {
      "defaultAddress": _vm.defaultAddress
    },
    on: {
      "change": _vm.changeRegion
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.handleSynchronous()
      }
    }
  }, [_vm._v("点击地区同步到标题")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "封面图"
    }
  }, [_c('div', [_c('div', {
    staticClass: "pics-box"
  }, [_c('ul', {
    staticClass: "goodspic-wrap"
  }, [_c('draggable', {
    staticClass: "components-view",
    attrs: {
      "options": _vm.dragIssuesOptions
    },
    model: {
      value: (_vm.form.pics),
      callback: function($$v) {
        _vm.$set(_vm.form, "pics", $$v)
      },
      expression: "form.pics"
    }
  }, _vm._l((_vm.form.pics), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "goodspic",
      on: {
        "mouseenter": function($event) {
          return _vm.picsEnter(index)
        },
        "mouseleave": _vm.picsLeave
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.wximageurl + item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "goodspic-mask",
      class: (_vm.picsCurrent == index) ? 'on' : ''
    }, [_c('div', {
      staticClass: "iconfont icon-trash-alt",
      on: {
        "click": function($event) {
          return _vm.removePicsImg(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "iconfont icon-arrows-alt"
    })])])
  }), 0)], 1), _vm._v(" "), (_vm.form.pics.length < 9) ? _c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handlePicsChange
    }
  }, [_c('i', {
    staticClass: "iconfont icon-camera"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('p', [_vm._v("1. 最多可上传9个图片，文件格式为bmp、png、jpeg、jpg或gif，大小不超过2M（建议尺寸：500px * 500px）")]), _vm._v(" "), _c('p', [_vm._v("2. 拖动图片进行可排序")])])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.picsDialog,
      "sc-status": _vm.isGetPics,
      "is-most": _vm.multiple
    },
    on: {
      "chooseImg": _vm.pickPics,
      "closeImgDialog": _vm.closePicsDialog
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "封面图样式"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.img_style),
      callback: function($$v) {
        _vm.$set(_vm.form, "img_style", $$v)
      },
      expression: "form.img_style"
    }
  }, _vm._l((_vm.imgStyle), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    style: ('height:' + (_vm.wheight - 195) + 'px;')
  }, [_c('richText', {
    attrs: {
      "control": ['film', 'goods', 'slider', 'heading', 'writing'],
      "data": _vm.form.content
    },
    on: {
      "change": _vm.handleRichTextChange
    }
  })], 1)])], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.thumbDialog,
      "sc-status": _vm.isGetThumb
    },
    on: {
      "chooseImg": _vm.pickThumb,
      "closeImgDialog": _vm.closeThumbDialog
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5cf4df5a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cf4df5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/planting/editor.vue
// module id = 2751
// module chunks = 0